import { Controller } from "stimulus";
import Swiper from "swiper";

import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';


import debounce from 'config/debounce.js';

export default class extends Controller {

  static targets = ['description', 'descriptionToggle']

  connect() {
    this.tabletPortrait = 700
    this.tabletLandscape = 1024
    this.desktop = 1200
    this.clientWidth = document.documentElement.clientWidth

    let heroCarouselContainer = this.element.querySelector('.ListingDetail__hero-section-carousel-container')
    let heroCarouselThumbnailContainer = this.element.querySelector('.ListingDetail__hero-section-carousel-thumbnail-container')
    let heroCarouselFooter = this.element.querySelector('.ListingDetail__hero-section-carousel-footer')
    let heroCarouselCurrentIndexTracker = this.element.querySelector('.js-ListingDetail__hero-section-carousel-tracker-container__current-index')

    let heroSwiperGrid = Array.from(heroCarouselContainer.querySelectorAll('.ListingDetail__hero-section-image')).map((item, index) => {
      const grid = index % 2 === 0 ? [1,1] : [2,1]
      return grid
    });

    this.heroImageSwiper = new Splide( '.ListingDetail__hero-section-carousel-container', {
      type   : 'slide',
      perPage: 2,
      perMove: 1,
      gap: '8px',
      height: '80vh',
      arrows: false,
      pagination: false,
      grid   : {
        dimensions: heroSwiperGrid,
        gap: {
          row: '8px',
          col: '8px',
        },
      },
      classes: {
        arrows: 'splide__arrows ListingDetail__hero-section-carousel-arrows',
        arrow : 'splide__arrow ListingDetail__hero-section-carousel-arrow',
        prev  : 'splide__arrow--prev ListingDetail__hero-section-carousel-button ListingDetail__hero-section-carousel-previous-button',
        next  : 'splide__arrow--next ListingDetail__hero-section-carousel-button ListingDetail__hero-section-carousel-next-button',
      },
      mediaQuery: 'min',
      breakpoints: {
        300: {
          perPage: 1,
          arrows: false,
          height: '60vh',
        },
        600: {
          perPage: 2,
          arrows: false,
          height: '80vh',
        },
      },
    } );

    this.heroImageSwiper.mount( { Grid } );

    // this.initBookNowControls()

    window.addEventListener(
      "scroll", () => {
        debounce(this.resetBookNow())
      }
    )

  }

  resetBookNow() {
    let container = document.querySelector('.ListingDetail__side-content-container-desktop')
    let bookNowWidget = document.querySelector('.BookNow__component')
    if (!container || !bookNowWidget) return;
    let containerHeight = container.offsetHeight;
    let bookNowWidgetHeight = bookNowWidget.offsetHeight

    if ( (window.pageYOffset + bookNowWidgetHeight) <= (containerHeight)) {
      bookNowWidget.classList.remove('BookNow__component-fix-bottom')
    } else {
      bookNowWidget.classList.add('BookNow__component-fix-bottom')
    }


  }

  animate(entries, observer) {
    entries.forEach(entry => {

      let targetElement = document.querySelector('.BookNow__component')

      if (entry.intersectionRatio > 0.1) {

        if (targetElement.classList.contains('BookNow__component-fix-bottom')) {
          targetElement.classList.remove('BookNow__component-fix-bottom')
        }
      }
    })
  }

  initBookNowControls() {
    if (this.intersectionObserverIsSupported() && this.isDesktopOrGreater()) {
      setTimeout(() => {
        this.setBookNowControls();
      }, 500)

      let options = {
        threshold: 0.1
      }

      let observer = new IntersectionObserver(this.animate.bind(this), options);

      observer.observe(document.querySelector('.ListingDetail__meet-owner-section'));
    }
  }

  setBookNowControls() {

    let targetElement = document.querySelector('.BookNow__component')
    let sectionElement = document.querySelector('.ListingDetail__map-section')

    if (targetElement && sectionElement) {
      let fixBookNowToBottomDebounce = debounce(
        () => {
          let targetRect = targetElement.getBoundingClientRect();
          let sectionRect = sectionElement.getBoundingClientRect();

          let targetTop = targetRect.top + document.body.scrollTop
          let targetHeight = parseFloat(getComputedStyle(targetElement, null).height.replace("px", ""))

          let sectionTop = sectionRect.top + document.body.scrollTop
          let sectionHeight = parseFloat(getComputedStyle(sectionElement, null).height.replace("px", ""))

          if ((targetTop + targetHeight) < (sectionTop + sectionHeight) && (targetTop + targetHeight > sectionTop)) {

            if (!targetElement.classList.contains('BookNow__component-fix-bottom')) {
              targetElement.classList.add('BookNow__component-fix-bottom')
            }
          }


        }
      )

      window.addEventListener(
        "scroll", () => {
          fixBookNowToBottomDebounce()
        }
      )
    }

  }

  intersectionObserverIsSupported() {
    return !this.noIntersectionObserverSupport();
  }

  noIntersectionObserverSupport() {
    return !('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype);
  }

  isDesktopOrGreater() {
    return this.clientWidth >= this.desktop
  }

  isMobile() {
    return this.clientWidth < this.tabletPortrait
  }

  isTablet() {
    return ((this.clientWidth >= this.tabletPortrait) && !(this.clientWidth >= this.desktop))
  }

  openLightbox(event) {
    event = new CustomEvent("lightbox-open", { bubbles: true });
    this.element.dispatchEvent(event);
  }


  toggleAmenities(event) {
    event.preventDefault();

    let amenitiesListElement = document
      .querySelector('.ListingDetail__amenities-list')

    amenitiesListElement.classList.toggle('ListingDetail__flex-reveal')
    let textContainer = document.querySelector('.ListingDetail__amenities-reveal-text')
    let plusIcon = document.querySelector('.js-ListingDetail__amenity-plus-icon')
    let minusIcon = document.querySelector('.js-ListingDetail__amenity-minus-icon')

    if (amenitiesListElement.classList.contains('ListingDetail__flex-reveal')) {
      if (textContainer) textContainer.innerHTML = "See Less Amenities & Features"
      if (plusIcon) plusIcon.setAttribute('style', 'display: none;')
      if (minusIcon) minusIcon.setAttribute('style', 'display: flex;')
    } else {
      if (textContainer) textContainer.innerHTML = "See All Amenities & Features"
      if (plusIcon) plusIcon.setAttribute('style', 'display: flex;')
      if (minusIcon) minusIcon.setAttribute('style', 'display: none;')
    }

  }

  toggleFloors(event) {
    event.preventDefault();

    let floorsElement = document.querySelector('.js-ListingDetail__additional-floors')

    floorsElement.classList.toggle('ListingDetail__flex-reveal')

    if (floorsElement.classList.contains('ListingDetail__flex-reveal')) {
      document.querySelector('.js-ListingDetail__floor-plus-icon').setAttribute('style', 'display: none;')
      document.querySelector('.js-ListingDetail__floor-minus-icon').setAttribute('style', 'display: flex;')
    } else {
      document.querySelector('.js-ListingDetail__floor-plus-icon').setAttribute('style', 'display: flex;')
      document.querySelector('.js-ListingDetail__floor-minus-icon').setAttribute('style', 'display: none;')
    }
  }

  toggleHighlight(event) {
    let clickedElement = event.currentTarget;
    let heroCarousel = Array.from(clickedElement.classList).find((item) => item.includes('hero'))

    if (heroCarousel) {
      return this.heroHighlight(clickedElement)
    }
  }

  heroHighlight(clickedElement) {
    let node = clickedElement.querySelector('.js-ListingDetail__hero-carousel-button')

    if (!node.classList.contains('ListingDetail__hero-carousel-button-highlighted')) {
      let highlightedNode = document.querySelector('.ListingDetail__hero-carousel-button-highlighted')
      highlightedNode.classList.remove('ListingDetail__hero-carousel-button-highlighted')
      node.classList.add('ListingDetail__hero-carousel-button-highlighted')
    }
  }

  toggleDescription(event) {
    event.preventDefault();
    let textMap = {
      'Show More': 'Show Less',
      'Show Less': 'Show More'
    }
    this.descriptionTarget.classList.toggle('expand')
    this.descriptionToggleTarget.innerText = textMap[this.descriptionToggleTarget.innerText]
    if (this.descriptionTarget.classList.contains('expand')) {
      document.querySelector('.js-ListingDetail__description-plus-icon').setAttribute('style', 'display: none;')
      document.querySelector('.js-ListingDetail__description-minus-icon').setAttribute('style', 'display: flex;')
    } else {
      document.querySelector('.js-ListingDetail__description-plus-icon').setAttribute('style', 'display: flex;')
      document.querySelector('.js-ListingDetail__description-minus-icon').setAttribute('style', 'display: none;')
    }
  }
}
